import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import LandingPage from "@/pages/LandingPage";
import PublicMenu from "@/pages/PublicMenu";
import InquiryFlow from "@/pages/InquiryFlow";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ContractsList from "@/pages/ContractsList";
import ContractEditor from "@/pages/ContractEditor";
import ChangeRequests from "@/pages/ChangeRequests";
import Calendar from "@/pages/Calendar";
import QuotesList from "@/pages/QuotesList";
import QuoteEditor from "@/pages/QuoteEditor";
import MenuManager from "@/pages/MenuManager";
import PublicMenuManager from "@/pages/PublicMenuManager";
import Inquiries from "@/pages/Inquiries";
import CustomerPortal from "@/pages/CustomerPortal";
import CustomerQuotePortal from "@/pages/CustomerQuotePortal";
import CustomerInvoicePortal from "@/pages/CustomerInvoicePortal";
import RequireAdmin from "@/components/RequireAdmin";
import AdminLayout from "@/components/AdminLayout";
import RequireEmployee from "@/components/RequireEmployee";
import EmployeeLayout from "@/components/EmployeeLayout";
import EmployeeLogin from "@/pages/EmployeeLogin";
import EmployeeCalendar from "@/pages/EmployeeCalendar";
import AdminEmployees from "@/pages/AdminEmployees";
import AdminActivity from "@/pages/AdminActivity";
import InvoicesList from "@/pages/InvoicesList";
import InvoiceEditor from "@/pages/InvoiceEditor";
import { AdminInventory, EmployeeInventory, AdminCheckouts, EmployeeCheckouts } from "@/pages/PortalWrappers";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/menu" element={<PublicMenu />} />
          <Route path="/inquire" element={<InquiryFlow />} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<RequireAdmin />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/inquiries" element={<Inquiries />} />
              <Route path="/admin/contracts" element={<ContractsList />} />
              <Route path="/admin/contracts/new" element={<ContractEditor mode="create" />} />
              <Route path="/admin/contracts/:id" element={<ContractEditor mode="edit" />} />
              <Route path="/admin/quotes" element={<QuotesList />} />
              <Route path="/admin/quotes/new" element={<QuoteEditor mode="create" />} />
              <Route path="/admin/quotes/:id" element={<QuoteEditor mode="edit" />} />
              <Route path="/admin/menu" element={<MenuManager />} />
              <Route path="/admin/public-menu" element={<PublicMenuManager />} />
              <Route path="/admin/calendar" element={<Calendar />} />
              <Route path="/admin/change-requests" element={<ChangeRequests />} />
              <Route path="/admin/invoices" element={<InvoicesList />} />
              <Route path="/admin/invoices/new" element={<InvoiceEditor />} />
              <Route path="/admin/invoices/:id" element={<InvoiceEditor />} />
              <Route path="/admin/employees" element={<AdminEmployees />} />
              <Route path="/admin/activity" element={<AdminActivity />} />
              <Route path="/admin/inventory" element={<AdminInventory />} />
              <Route path="/admin/checkouts" element={<AdminCheckouts />} />
            </Route>
          </Route>

          {/* Employee portal */}
          <Route path="/employee/login" element={<EmployeeLogin />} />
          <Route element={<RequireEmployee />}>
            <Route element={<EmployeeLayout />}>
              <Route path="/employee" element={<EmployeeCalendar />} />
              <Route path="/employee/inventory" element={<EmployeeInventory />} />
              <Route path="/employee/checkouts" element={<EmployeeCheckouts />} />
            </Route>
          </Route>

          {/* Customer portals */}
          <Route path="/c/:token" element={<CustomerPortal />} />
          <Route path="/q/:token" element={<CustomerQuotePortal />} />
          <Route path="/i/:token" element={<CustomerInvoicePortal />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}
